export { TRIAL_INTRO_MODAL_KEY } from '@/app/constants/modals';
export const TRIAL_INTRO_SEEN_CALLOUT = '101_trial_intro_modal';
export const TRIAL_INTRO_UPGRADE_SOURCE = 'trial-welcome-modal';
